




































































































import { Component, Vue, Inject } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Headquarter } from '@/data/models/headquarter.model';
import { Search, SortDirection } from '@/data/models/search.model';

@Component
export default class HeadquarterList extends Vue {
	@Inject('CrudService') crudService!: CrudService<Headquarter>;

	rows: Headquarter[] = [];
	loading: boolean = false;

	advancedSearch: Search = new Search('headquarter');

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadHeadquarters() {

		const datareq = this.crudService.searchEntities(
			Headquarter,
			'headquarter',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Headquarter,
			'headquarter',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	openHeadquarter(item: Headquarter) {
		this.$emit('open', item);
	}

	deleteHeadquarter(item: Headquarter) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadHeadquarters();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadHeadquarters();
	}

}
